/**
 * Application entry point.
 *
 * This file includes `import`'s for all the components/directives used
 * by the HTML page and the controller to provide the configuration.
 */
import './sass/desktop.scss';

import angular from 'angular';
import {isEventUsingCtrlKey} from 'ngeo/utils';
import gmfControllersAbstractDesktopController, {
  AbstractDesktopController,
} from 'gmf/controllers/AbstractDesktopController';
import geocommunesBase, {init} from '../geocommunesmodule';
import ngeoMiscToolActivate from 'ngeo/misc/ToolActivate';
import ngeoStreetviewModule from 'ngeo/streetview/module';
import panels from 'gmfapi/store/panels';

/**
 * @param {angular.Scope} $scope Scope.
 * @param {angular.$injector} $injector Main injector.
 * @constructor
 * @extends {gmf.controllers.AbstractDesktopController}
 * @export
 * @private
 */
class Controller extends AbstractDesktopController {
  /**
   * @param {angular.IScope} $scope Scope.
   * @param {angular.auto.IInjectorService} $injector Main injector.
   * @param {string} geocommuneCss
   */
  constructor($scope, $injector, geocommuneOptions) {
    super($scope, $injector);
    init($injector, geocommuneOptions);
    // Allow angular-gettext-tools to collect the strings to translate
    // something like hidden attributes in Mapfiles
    /** @type {angular.gettext.gettextCatalog} */
    this.gettextCatalog = $injector.get('gettextCatalog');

    /**
     * @type {string}
     */
    this.clientUrl = geocommuneOptions.clientUrl;

    /**
     * @type {boolean}
     */
    this.pageIsSDOL = geocommuneOptions.title === 'sdol.geocommunes.ch';

    const $timeout = $injector.get('$timeout');

    /**
     * @type {boolean}
     */
    this.drawLidarprofilePanelActive = false;

    /**
     * @type {boolean}
     */
    this.lidarProfileFooterActive = true;

    // Make visible the footer
    panels.getActiveFooterPanel().subscribe({
      next: (panel) => {
        this.lidarProfileFooterActive = panel === 'lidar';
        $timeout(() => {}); // this triggered on DOM click, we call $timeout to force Angular diggest
      },
    });

    const drawLidarprofilePanelActive = new ngeoMiscToolActivate(this, 'drawLidarprofilePanelActive');
    this.ngeoToolActivateMgr.registerTool('mapTools', drawLidarprofilePanelActive, false);

    /**
     * @type {boolean}
     */
    this.loaded = false;

    // open the component lidar panel when panel sould be active
    $scope.$watch(
      () => this.drawLidarprofilePanelActive,
      (newVal) => {
        if (newVal) {
          panels.openToolPanel('lidar');
        } else {
          panels.closeToolPanel();
        }
      },
    );
  }

  /**
   * @param {JQuery.Event} event keydown event.
   */
  onKeydown(event) {
    if (event && isEventUsingCtrlKey(event) && event.key === 'p') {
      this.printPanelActive = true;
      event.preventDefault();
    }
  }
}
Controller.$inject = ['$scope', '$injector', 'geocommuneOptions'];

const geocommunesModule = angular.module('Appdesktop', [
  geocommunesBase.name,
  gmfControllersAbstractDesktopController.name,
  ngeoStreetviewModule.name,
]);

geocommunesModule.value('gmfContextualdatacontentTemplateUrl', 'gmf/contextualdata');
geocommunesModule.run(
  /**
   * @param {angular.ITemplateCacheService} $templateCache
   */
  [
    '$templateCache',
    ($templateCache) => {
      // @ts-ignore: webpack
      $templateCache.put('gmf/contextualdata', require('./contextualdata.html'));
    },
  ],
);

geocommunesModule.controller('DesktopController', Controller);

export default geocommunesModule;
